import { useMediaQuery } from '@material-ui/core'
import { useTheme } from 'styled-components'
import { ClientLogoHeaderContainer } from './landingPage.styled'

interface ClientLogoHeaderProps {
	logoSrc: string
	clientName: string
}

export const ClientLogoHeader = ({
	logoSrc,
	clientName,
}: ClientLogoHeaderProps) => {
	const LARGE_SCREEN_LOGO_WIDTH = '280px'
	const SMALL_SCREEN_LOGO_WIDTH = '165px'

	const isLarge = useMediaQuery(useTheme().breakpoints.up('sm'))

	return (
		<ClientLogoHeaderContainer>
			{logoSrc ? (
				<img
					width={isLarge ? LARGE_SCREEN_LOGO_WIDTH : SMALL_SCREEN_LOGO_WIDTH}
					height="auto"
					src={logoSrc}
					alt={`Logo of ${clientName}`}
				/>
			) : null}
		</ClientLogoHeaderContainer>
	)
}
